import { render, staticRenderFns } from "./ConsultaTurnos.vue?vue&type=template&id=d038eeee&"
import script from "./ConsultaTurnos.vue?vue&type=script&lang=js&"
export * from "./ConsultaTurnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports